import LegalLayout, { LP, LL, LMail } from "@/components/LegalLayout";

const SECTIONS = [
  {
    heading: "1. Scope",
    body: (
      <LP>
        This Refund Policy applies to all services purchased from{" "}
        <strong className="text-white">4EMPIRE</strong>. Because our services are custom
        professional work (strategy, creative production, campaign management), they are not
        products that can be returned — this policy explains how cancellations and refunds are
        handled fairly.
      </LP>
    ),
  },
  {
    heading: "2. Deposits",
    body: (
      <LL
        items={[
          "Before work has started: a paid deposit is fully refundable on simple written request.",
          "Once work has started: the deposit becomes non-refundable, as it covers time reserved and work already begun.",
        ]}
      />
    ),
  },
  {
    heading: "3. Delivered work",
    body: (
      <LP>
        Deliverables and milestones that have been completed and delivered are never refundable.
      </LP>
    ),
  },
  {
    heading: "4. Mid-project cancellation",
    body: (
      <LP>
        If you cancel an ongoing engagement, you pay for the work performed up to the cancellation
        date. Any amount paid beyond the value of work performed is refunded within 14 days of
        cancellation.
      </LP>
    ),
  },
  {
    heading: "5. Retainers & recurring services",
    body: (
      <LP>
        Recurring services (for example social media management or ad campaign management) can be
        cancelled with the notice period defined in your quote or contract. The current period
        remains due; no refund is due for a period already started.
      </LP>
    ),
  },
  {
    heading: "6. If we cannot deliver",
    body: (
      <LP>
        If 4EMPIRE is unable to deliver the agreed service for reasons within its control, the
        portion of the service not performed is refunded in full.
      </LP>
    ),
  },
  {
    heading: "7. EU consumer right of withdrawal",
    body: (
      <LP>
        If you contract with us as a consumer within the European Union, you may benefit from a
        statutory 14-day right of withdrawal. If you ask us to start work during that period, you
        will owe a proportional amount for work performed if you then withdraw.
      </LP>
    ),
  },
  {
    heading: "8. How to request a refund",
    body: (
      <>
        <LP>
          Write to us at <LMail /> with your name, company and the quote or invoice reference. We
          reply within 5 business days. Approved refunds are processed within 14 days, using the
          original payment method where possible.
        </LP>
      </>
    ),
  },
];

export default function RefundPolicy() {
  return (
    <LegalLayout
      testid="refund-policy"
      title="Refund"
      accent="Policy."
      description="Last updated: October 2026. How 4EMPIRE handles deposits, cancellations and refunds for its services."
      sections={SECTIONS}
    />
  );
}
